import React from "react";

function Textarea(props) {

  const { textColor, bgColor, ...rest } = props;

  let tColor = "text-gray-700";
  if (textColor) tColor = textColor; // overwrite

  let bColor = "bg-white";
  if (bgColor) bColor = bgColor; // overwrite

  return (
    <textarea
      className={`shadow-inner h-18 border rounded w-full p-2 focus:shadow-md focus:outline-none ${tColor} ${bColor}`}
      {...rest}
    />
  );
}

export default Textarea;
